// 步骤条-方向属性
export const DirectionEnum = Object.freeze({
  HORIZONTAL: 'horizontal', // 水平
  VERTICAL: 'vertical', // 竖直
});

// 步骤条-大小尺寸属性
export const SizeEnum = Object.freeze({
  DEFAULT: 'default', // 默认大小
  SMALL: 'small', // 迷你
});
